import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  container: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    gap: '1rem',

    margin: 0,
    overflow: 'hidden',
    flex: 0,
    padding: 'var(--ui-coupon-card-padding)',
    backgroundColor: 'var(--ui-coupon-card-background-color)',
    borderRadius: 'var(--ui-coupon-card-border-radius)',
    boxShadow: 'var(--ui-coupon-card-box-shadow)',
    cursor: 'pointer',
  },
  disabled: {
    opacity: 0.5,
    cursor: 'default',
  },
  upperContent: {
    gap: '1rem',
    flex: 1,
    display: 'flex',
    flexDirection: 'var(--ui-coupon-card-flex-direction)',
    alignItems: 'flex-start',
  },
  link: {
    textDecoration: 'none',
    flexGrow: 1,
  },
  figure: {
    position: 'relative',
    margin: 0,
    width: '100%',
    flexShrink: 0,

    flexBasis: 'var(--ui-coupon-card-thumbnail-width)',
    maxWidth: 'var(--ui-coupon-card-thumbnail-max-width)',
    aspectRatio: 'var(--ui-coupon-card-image-aspect-ratio)',
  },
  image: {
    aspectRatio: 'var(--ui-coupon-card-image-aspect-ratio)',
    borderRadius: 'var(--ui-coupon-card-image-border-radius)',
    overflow: 'hidden',
    objectFit: 'cover',
    objectPosition: 'center center',
    width: '100%',
    height: '100%',
    display: 'block',
    margin: 0,
  },
  content: {
    color: 'var(--ui-color-text)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: 'var(--ui-coupon-card-content-text-align)',
    padding: 'var(--ui-coupon-card-content-padding)',
  },
  contentText: {
    marginBottom: '0.2rem',
    fontSize: '1.4rem',
    lineHeight: '1.42em',
  },
  title: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
    wordBreak: 'break-word',
  },
  details: {
    // display: 'none',
    display: 'var(--ui-coupon-card-content-details-display)',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    overflow: 'hidden',
    color: 'var(--ui-color-info)',
  },
  footer: {
    padding: 'var(--ui-coupon-card-footer-padding)',
    display: 'flex',
    gap: 'var(--ui-spacer-s)',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    fontSize: '1.2rem',
    lineHeight: 1.25,
  },
  footerLeft: {
    flexShrink: 1,
    textAlign: 'left',
  },
  footerRight: {
    flexShrink: 0,
    textAlign: 'right',
  },
  usableCouponTokenCountContainer: {
    extend: 'footer',
    alignItems: 'stretch',
  },
  usableCouponTokenCount: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    width: '100%',
    maxWidth: '37rem',
  },
  usableCouponTokenCountLabel: {
    fontSize: '1.2rem',
    lineHeight: 1.33,
    padding: '0.2em 1em',
    borderRadius: '1.2rem',
    backgroundColor: 'var(--ui-coupon-card-usable-coupon-token-count-label-background-color)',
    color: 'var(--ui-coupon-card-usable-coupon-token-count-label-color)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))

export default useStyles
